
export const environment = {
  production: true,
  showPoweredBy: true,
  // Pantalla de arranque en `/` (RECI-F02). `home` es lo de siempre; una instalacion que
  // entra por otra pantalla —una gimkana, por ejemplo— lo cambia SIN tocar el codigo, con
  // la configuracion de arranque del contenedor. Un valor que no sea una ruta existente cae
  // en `not-found`, asi que se comprueba al desplegar.
  startPath: 'home',
  apiUrlBase: 'https://cicerone.cms-iurban.com',
  // 🔴 De donde se bajan los textos de la interfaz, ADEMAS de los del propio bundle.
  // Vacio = solo los del bundle, que es lo que queremos y lo que hace RECI.
  //
  // El cargador funde local←remoto y **manda el remoto**, asi que esto no es una URL mas: es
  // quien decide los textos de la pantalla. Medido el 10-sep contra `/langs/*.php` del CMS:
  // de las 135 claves en castellano no cambiaria ninguna, pero en ingles llegarian
  // «Transportes»→«Yipiakiyeah», «Playas Urbanas»→«test», «Hospitales»→«boqpasa»; en frances
  // «Salud»→«santo es el señor»; y en catalan, aleman, gallego, neerlandes y valenciano mas de
  // lo mismo, 46 textos en total. Son datos de prueba que viven en `public/langs/*.json` del
  // CMS y viajan con el, no algo de este evento.
  //
  // Hasta hoy no llegaban por un accidente: esos ficheros sirven
  // `Access-Control-Allow-Origin: http://localhost:8100` escrito a mano, asi que el navegador
  // los bloquea y el remoto cae a `{}`. Es decir, **lo unico que nos separaba de enseñar
  // «Yipiakiyeah» en el congreso era un fallo de CORS**. Por eso se apaga a proposito y por
  // configuracion, en vez de dejarlo colgando de que ese fallo siga ahi.
  langsUrlBase: '',
  apiAssistantUrlBase: 'https://v3.gpt.cms-iurban.com',
  urlWebSocket: 'wss://v3.gpt.cms-iurban.com/ws/assistant',
  urlWebSocketTools: 'wss://v3.gpt.cms-iurban.com/ws/assistant/tool-feedback',
  urlChatHistory: 'https://v3.gpt.cms-iurban.com/api/chat/history',
  urlTextToSpeech: 'https://v3.gpt.cms-iurban.com/tts/stream',
  googleMapsApiKey: 'AIzaSyCosmIo9py_6Dfd_mr1CWSJxQtDzl1LWjA',
  googlePlacesApiKey: 'AIzaSyCs0X4MMRnYLRqwpflGDnr64FQ7QXviFko',
  // 🔴 RECI-D06. Vacío = las fichas no ofrecen «descargar en PDF». Medido el 14-sep:
  // `node.ciceroneweb.com/details-pdf` devuelve **500** cuando la petición lleva
  // `Origin: https://reci.iurban.ai`, y devuelve el PDF (200) sin Origin o desde un dominio
  // que sí tiene en su lista. O sea: desde el navegador del visitante ese botón solo sabe dar
  // error. Se apaga aquí, y no tocando ese servicio, porque es de producción y es el SPOF.
  pdfServiceUrl: '',
  ticketingTokenEncoded: 'MGZhOWQzYjZlMmMxNDEyZjhmMmIxZTYwNGM3M2VkMjA1YTBiNGEzYmYyY2RkZTY2YzU2NGUxNzlmMDdjYWUxNw==',
  serviceWorker: true,
  // HRS-3045: Sentry solo se descarga (chunk propio) si hay DSN. null = sin Sentry.
  // DSN histórico del proyecto (desactivado desde que se puso a null en main.ts):
  // 'https://ac6f0b26fe5ef3f66265dc6f5577273e@o4510035615416320.ingest.de.sentry.io/4510061988282448'
  sentryDsn: null as string | null,

  pdfExportCCMM: {
    enabled: false,
    frontendUrl: 'https://miruta.visitmadrid.es/front',
    backendUrl: 'https://miruta.visitmadrid.es/cms/api/details-pdf',
  },
  // Offline base-map tiles for downloaded hiking routes. urlTemplate must
  // point to a source whose terms PERMIT offline caching (self-hosted
  // OSM-derived raster {z}/{x}/{y}.png). Never OSM/Google tile servers.
  // Empty urlTemplate = feature disabled (safe no-op, blank base map).
  offlineTiles: {
    urlTemplate: 'https://cms-iurban.com/osm/{z}/{x}/{y}.png',
    maxZoom: 16,
    maxTilesPerRoute: 3000,
  }
};

//from 10 tp 15 juliy, i travel in couple, i want to see culture, gastronomy, nature, shopping, events, local life, visit center and 30km
